<template>
  <div class="category-wrapper">
    <!-- <layout> -->
    <Tabbar></Tabbar>
    <!-- <div  class="con"> -->
    <div class="con">
      <div class="left">
        <div
          class="conter"
          v-for="(item, index) in CategoryList"
          :key="item.category_id"
          @click="jumpTo(item.category_id, index)"
        >
          {{ item.name }}
          <div class="normal" :class="{ active: activeIndex == index }"></div>
        </div>
      </div>
      <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
      <div class="list-wrapper">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :offset="500"
        >
          <div class="cateImg" ref="title">
            <img
              :src="CategoryList[CategoryActiveImg].pad_image.file_path"
              v-if="CategoryList.length > 0"
            />
          </div>
          <div class="middle_content" ref="content">
            <div
              class="item"
              v-for="(items, index) in goodsList"
              :key="index"
              @click="jump(items.goods_id)"
            >
              <!-- <div class="item" v-for="(items, index) in goodsList" :key="index"> -->
              <div class="img">
                <img
                  :src="items.image[0].file_path | thumbnail(720, 720)"
                  alt
                />
              </div>
              <div class="message">
                <div class="des" style="font-size: 16px">
                  <p>{{ items.goods_name }}</p>
                  <p>产品编号：{{ items.goods_number }}</p>
                  <p>克重(g)：{{ items.sku[0].goods_weight }}</p>
                </div>
                <!-- <div v-if="!token" class="price">
                      ￥{{ items.goods_max_price }}
                    </div> -->
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <!-- </layout> -->
  </div>
</template>
<script>
import layout from "@/components/layout.vue";
import { getCategory, getList } from "../../api/http.js";
import { animateCSS } from "../../utils/animate.js";
import axios from "axios";
import BScroll from "@better-scroll/core";
import Pullup from "@better-scroll/pull-up";
BScroll.use(Pullup);

import Tabbar from "@/components/Tabbar.vue";

export default {
  components: {
    layout,
    Tabbar
  },
  data() {
    return {
      token: "",
      CategoryList: [],
      CategoryActiveImg: 0,
      goodsList: [],
      ids: 0,
      activeIndex: 0,
      category_id: 0,
      itemsize: false,
      isLoading: false,
      loading: false,
      finished: false,
      currentPage: 0,
      pagecount: 1,
      scroll: 0
    };
  },

  created() {
    this.token = localStorage.getItem("login_token");
    if (localStorage.getItem("getCategory_size") != null) {
      this.itemsize = Boolean(
        localStorage.getItem("getCategory_size") === "true"
      );
    }
    this.init(this.ids);
    // this.$nextTick(()=>{
    // this.scroll = new Bscroll(this.$refs.listWrapper, {})
    // })
  },
  activated() {
    document.body.style.background = "#eee";
  },
  deactivated() {
    document.body.style.background = "rgba(250, 250, 250, 1)";
  },
  mounted() {
    let app = document.querySelector("#app");
    app.style.width = "100%";
  },
  methods: {
    init(ids) {
      getCategory().then(res => {
        this.CategoryList = res.data.list.all;
        //page,sortType,sortPrice,category_id,search,wxapp_id
        animateCSS(".cateImg", "fadeInDown");
        // this.getList(1, "all", true, this.CategoryList[0].category_id, "", "");
      });
    },
    jumpTo(category_id, index) {
      this.currentPage = 0;
      this.category_id = category_id;
      this.CategoryActiveImg = index;
      this.activeIndex = index;
      // animateCSS(".cateImg", "fadeOutUp");
      // animateCSS(".middle_content", "fadeInDown");
      this.goodsList = [];
      this.onLoad();
      // this.getList(1, "all", true, category_id, "", "", true);
    },
    jump(ids) {
      this.$router.push({
        path: "/details",
        query: {
          //路由传参时push和query搭配使用 ，作用是传递参数
          id: ids
        }
      });
    },
    onLoad() {
      this.currentPage = parseInt(this.currentPage) + 1;
      this.getList(
        this.currentPage,
        "all",
        true,
        this.category_id,
        this.searchresult || "",
        this.token
      );
    },

    getList(
      page,
      sortType,
      sortPrice,
      category_id,
      search,
      token,
      tags,
      refresh = false
    ) {
      if (refresh) {
        this.finished = false;
        this.goodsList = [];
        animateCSS(".cateImg", "fadeInDown");
      }
      getList(
        page,
        sortType,
        sortPrice,
        category_id,
        search,
        this.token,
        tags
      ).then(res => {
        console.log(res);
        this.goodsList = this.goodsList.concat(res.data.list.data);
        this.currentPage = res.data.list.current_page;
        this.pagecount = res.data.list.last_page;
        if (page == 1) {
          animateCSS(".middle_content", "fadeInUp");
        }
        if (this.currentPage >= this.pagecount) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.left::-webkit-scrollbar {
  display: none;
}
.con {
  display: flex;
}
.middle_content {
  width: 500px;
}
#app {
  width: 1000px !important;
}

.category-wrapper {
  width: 1000px;
}

.left {
  position: fixed;
  left: 0;
  top: 44px;
  bottom: 0;
  width: 139px;
  line-height: 40px;
  text-align: center;
  background: #fff;
  height: 100vh;
  overflow-y: scroll;
}
.left .conter {
  font-size: 13px;
  color: #1a1a1a;
}
.left .conter .normal {
  margin: 0px auto;
  width: 30px;
  height: 4px;
  background: #fff;
}
.left .conter .active {
  margin: 0px auto;
  width: 30px;
  height: 4px;
  background: #3e210e;
}

.van-list {
  width: 101% !important;
}
.list-wrapper {
  margin-left: 150px;
  margin-top: 58px;
  width: calc(100% - 139px);
  //   width: 100%;
}
.cateImg {
  display: none;
  width: 100%;
  height: 210px;
  overflow: hidden;
  margin-bottom: 10px;
  border-radius: 4px;
}
.cateImg img {
  width: 100%;
  position: relative;
  transform: translateY(-50%);
  top: 50%;
}
.AnimateDelay {
  animation-delay: 500ms;
}
.middle_content {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  // padding-top: 15px;
}
.middle_content .item {
  width: 25%;
  height: 220px;
  box-sizing: border-box;
  margin-bottom: 10px;
  overflow: hidden;
  padding-left: 5px;
}
.middle_content .item .img {
  width: 100%;
  height: 80%;
  background: #000000;
  overflow: hidden;
}
.middle_content .item .img img {
  width: 100%;
  height: 100%;
  position: relative;
  object-fit: cover;
}
.middle_content .item .message {
  height: 20%;
  padding: 5px 0 0 5px;
  color: #3e210e;
  background: white;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow: hidden;
}
.middle_content .item .message .des {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.middle_content .item .message .des p {
  line-height:1;
  font-size: 10px;
  transform: translateX(-13px) scale(0.83, 0.83);
  margin: 0;
  margin-bottom:2px;
}
.right {
  position: fixed;
  right: 0;
  top: 44px;
  bottom: 0;
  width: 47px;
  line-height: 49px;
  text-align: center;
  background: #fff;
}
.right .conter {
  font-size: 13px;
}
.right .active {
  background: #3e210e;
}
</style>
